import styled from 'styled-components';

export const PriceCheckWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline-start: 8px;
`;
